module.exports = __webpack_public_path__ + "assets/img/zemes-savininkams.1e05a1b1.jpg";